import { render } from "./AppImageViewer.vue?vue&type=template&id=49ab2aa0&scoped=true"
import script from "./AppImageViewer.vue?vue&type=script&lang=js"
export * from "./AppImageViewer.vue?vue&type=script&lang=js"

import "./AppImageViewer.vue?vue&type=style&index=0&id=49ab2aa0&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ab2aa0"]])

export default __exports__